export enum Language {
  SI = 'SI',
  EN = 'EN',
}

export const LetterCode: Record<string, string> = {
  A: '10',
  B: '11',
  C: '12',
  Č: '13',
  Ć: '14',
  D: '15',
  Đ: '16',
  E: '17',
  F: '18',
  G: '19',
  H: '20',
  I: '21',
  J: '22',
  K: '23',
  L: '24',
  M: '25',
  N: '26',
  O: '27',
  P: '28',
  Q: '29',
  R: '30',
  S: '31',
  Š: '32',
  T: '33',
  U: '34',
  V: '35',
  W: '36',
  Z: '37',
  Ž: '38',
  X: '39',
  Y: '40',
};
